const BASE_DOMAIN = "www.litres.ru";

export const isTurkeyDomain = (domain: string = BASE_DOMAIN) => {
  return domain.includes("litres-tr.com");
};

export const isAzerbaijanDomain = (domain: string) => {
  return ["litres.az", "m.litres.az"].some(item => domain.includes(item));
};

export const isUzbekistanDomain = (domain: string) => {
  return ["litres.uz", "m.litres.uz"].some(item => domain.includes(item));
};

export const isPolishDomain = (domain: string) => {
  return ["litres.pl", "m.litres.pl"].some(item => domain.includes(item));
};

export const isSpanishDomain = (domain: string) => {
  return ["litres.es", "m.litres.es"].some(item => domain.includes(item));
};

export const isComDomain = (domain: string) => {
  return ["litres.com", "m.litres.com"].some(item => domain.includes(item));
};

export const isDeutschlandDomain = (domain: string) => {
  return ["litres.de", "m.litres.de"].some(item => domain.includes(item));
};

export const isEstonianDomain = (domain: string) => {
  return ["litres.ee", "m.litres.ee"].some(item => domain.includes(item));
};

export const isEuDomain = (domain: string) => {
  return ["litres.eu", "m.litres.eu"].some(item => domain.includes(item));
};

export const isUkranianDomain = (domain: string) => {
  return domain.includes("litres.ua");
};

export const isForeignDomain = (domain: string) => {
  return (
    isTurkeyDomain(domain) ||
    isAzerbaijanDomain(domain) ||
    isUzbekistanDomain(domain) ||
    isComDomain(domain) ||
    isDeutschlandDomain(domain) ||
    isEstonianDomain(domain) ||
    isEuDomain(domain) ||
    isPolishDomain(domain) ||
    isSpanishDomain(domain) ||
    isUkranianDomain(domain)
  );
};

export const isRuDomain = (domain: string) => {
  return domain.includes("litres.ru");
};

export const isEuropenianDomain = (domain: string) => {
  return (
    isComDomain(domain) ||
    isDeutschlandDomain(domain) ||
    isEstonianDomain(domain) ||
    isEuDomain(domain) ||
    isPolishDomain(domain) ||
    isSpanishDomain(domain)
  );
};

export const isSubscriptionDomain = (domain: string = BASE_DOMAIN) => {
  return ["subscription.litres.ru"].some(item => domain.includes(item));
};

export const isSchoolDomain = (domain: string = BASE_DOMAIN) => {
  return [
    "rusch.litres.ru",
    "pda-rusch.litres.ru",
    "sch.litres.ru",
    "pda-sch.litres.ru",
    "schfree.litres.ru",
    "pda-schfree.litres.ru",
    // школьные подписки
    "megaschool.litres.ru",
    "pda-megaschool.litres.ru",
    "rtkmegaschool.litres.ru",
    "pdartkmegaschool.litres.ru",
    "sch.litres.ru",
    "pda-sch.litres.ru",
    "schfree.litres.ru",
    "pda-schfree.litres.ru",
  ].some(item => domain.includes(item));
};

export const isBiblioDomain = (domain: string = BASE_DOMAIN) => {
  return [
    "biblio.litres.ru",
    "pda-biblio.litres.ru",
    "lib.litres.ru",
    "m-lib.litres.ru",
    "rblib.litres.ru",
    "m-rblib.litres.ru",
    "pro.litres.ru",
    "pda-pro.litres.ru",
    "promax.litres.ru",
    "m-promax.litres.ru",
    "univer.litres.ru",
    "pda-univer.litres.ru",
    "business.litres.ru",
    "m-business.litres.ru",
    "student-biblio.litres.ru",
    "pda-student-biblio.litres.ru",
    "liblitres.litres.ru",
    "pda-deti-biblio.litres.ru",
    "al.litres.ru",
    "pda-al.litres.ru",
    "rgbm-biblio.litres.ru",
    "pda-rgbm-biblio.litres.ru",
    "f.litres.ru",
    "m-f.litres.ru",
    "rs.litres.ru",
    "pda-rs.litres.ru",
    "bibliofree.litres.ru",
    "m-bibliofree.litres.ru",
    "ro.litres.ru",
    "pda-ro.litres.ru",
    "nf.litres.ru",
    "m-nf.litres.ru",
    // книговыдачи
    "al.litres.ru",
    "pda-al.litres.ru",
    "rs.litres.ru",
    "pda-rs.litres.ru",
    "f.litres.ru",
    "m-f.litres.ru",
    "nf.litres.ru",
    "m-nf.litres.ru",
    "ro.litres.ru",
    "pda-ro.litres.ru",
  ].some(item => domain.includes(item));
};

export const isMobileOperatorDomain = (domain: string = BASE_DOMAIN) => {
  return [
    "a1all.litres.ru",
    "a1allpda.litres.ru",
    "a1audio.litres.ru",
    "a1pdaaudio.litres.ru",
    "a1pdaread.litres.ru",
    "a1premium.litres.ru",
    "a1read.litres.ru",
    "all.litres.ru",
    "allmegafon.litres.ru",
    "audiomegafon.litres.ru",
    "azercelllisten.litres.ru",
    "azercellread.litres.ru",
    "beelinerusall.litres.ru",
    "beelineruslisten.litres.ru",
    "beelineruspremium.litres.ru",
    "beelinerusread.litres.ru",
    "beelineuzall.litres.ru",
    "beelineuzlisten.litres.ru",
    "beelineuzpremium.litres.ru",
    "beelineuzread.litres.ru",
    "inlab.litres.ru",
    "inlabpda.litres.ru",
    "kcellpdaread.litres.ru",
    "kcellread.litres.ru",
    "lifebelread.litres.ru",
    "lifebelreadpda.litres.ru",
    "listen.litres.ru",
    "megafon.litres.ru",
    "megafonpluspremium.litres.ru",
    "megafonvip.litres.ru",
    "mtsrball.litres.ru",
    "mtsrbpremium.litres.ru",
    "mtsrbread.litres.ru",
    "mvprostelecom.litres.ru",
    "myschool.litres.ru",
    "pda-myschool.litres.ru",
    "pdaa1premium.litres.ru",
    "pdaall.litres.ru",
    "pdaallmegafon.litres.ru",
    "pdaaudiomegafon.litres.ru",
    "pdaazercelllisten.litres.ru",
    "pdaazercellread.litres.ru",
    "pdabeelinerusall.litres.ru",
    "pdabeelineruslisten.litres.ru",
    "pdabeelineruspremium.litres.ru",
    "pdabeelinerusread.litres.ru",
    "pdabeelineuzall.litres.ru",
    "pdabeelineuzlisten.litres.ru",
    "pdabeelineuzpremium.litres.ru",
    "pdabeelineuzread.litres.ru",
    "pdalisten.litres.ru",
    "pdamegafon.litres.ru",
    "pdamegafonpluspremium.litres.ru",
    "pdamegafonvip.litres.ru",
    "pdamtsrball.litres.ru",
    "pdamtsrbpremium.litres.ru",
    "pdamtsrbread.litres.ru",
    "pdapremium.litres.ru",
    "pdaread.litres.ru",
    "pdareadgenre.litres.ru",
    "pdasbprime.litres.ru",
    "pdasbprimepremium.litres.ru",
    "pdasbprimekzread.litres.ru",
    "pdatele2kzall.litres.ru",
    "pdatele2kzlisten.litres.ru",
    "pdatele2kzread.litres.ru",
    "pdatele2rusall.litres.ru",
    "pdatele2ruslisten.litres.ru",
    "pdatele2ruspremium.litres.ru",
    "pdatele2rusread.litres.ru",
    "pdaucellread.litres.ru",
    "pdayotalisten.litres.ru",
    "pdayotaread.litres.ru",
    "premium.litres.ru",
    "read.litres.ru",
    "readgenre.litres.ru",
    "sbprime.litres.ru",
    "sbprimepremium.litres.ru",
    "sbprimekzread.litres.ru",
    "tele2kzall.litres.ru",
    "tele2kzlisten.litres.ru",
    "tele2kzread.litres.ru",
    "tele2rusall.litres.ru",
    "tele2ruslisten.litres.ru",
    "tele2ruspremium.litres.ru",
    "tele2rusread.litres.ru",
    "tinkoffread.litres.ru",
    "tinkoffreadpda.litres.ru",
    "ucellread.litres.ru",
    "yotalisten.litres.ru",
    "yotaread.litres.ru",
    "volnamobilepremium.litres.ru",
    "volnamobile.litres.ru",
    "mvideo.litres.ru",
    "mvideopda.litres.ru",
    "allyota.litres.ru",
    "pdaallyota.litres.ru",
    "dns.litres.ru",
    "dnspda.litres.ru",
  ].some(item => domain.includes(item));
};

export const isRostelecomDomain = (domain: string = BASE_DOMAIN) => {
  return [
    "read.litres.ru",
    "listen.litres.ru",
    "all.litres.ru",
    "premium.litres.ru",
    "readgenre.litres.ru",
    "mvprostelecom.litres.ru",
  ].some(item => domain.includes(item));
};

export const isAvailableForPPDMegafonDomain = (
  domain: string = BASE_DOMAIN
) => {
  return [
    "megafon.litres.ru",
    "audiomegafon.litres.ru",
    "allmegafon.litres.ru",
    "myschool.litres.ru",
    "megafonvip.litres.ru",
    "pdamegafon.litres.ru",
    "pdaallmegafon.litres.ru",
    "megafonpluspremium.litres.ru",
    "pdamegafonpluspremium.litres.ru",
    "pdamegafonvip.litres.ru",
    "www.litres.ru",
  ].some(item => domain.includes(item));
};

export const isStageDomain = (domain: string) => {
  return domain.includes("litres.io");
};

export const isLitresDomain = (domain: string = BASE_DOMAIN): boolean => {
  return (
    isRuDomain(domain) ||
    isForeignDomain(domain) ||
    isSubscriptionDomain(domain) ||
    isSchoolDomain(domain) ||
    isBiblioDomain(domain) ||
    isMobileOperatorDomain(domain) ||
    isRostelecomDomain(domain) ||
    isStageDomain(domain)
  );
};
